@import 'common/component';

:host {
  display: block;
}

.breadcrumbs-item {
  display: flex;
  align-items: center;
  font-size: 1.4rem;
  line-height: 1.3;
  font-weight: 400;

  &:not(.breadcrumbs-item--orphan):not(.breadcrumbs-item--last-child) {
    display: none;
  }

  @media (min-width: 768px) {
    &:not(.breadcrumbs-item--orphan):not(.breadcrumbs-item--last-child) {
      display: flex;
    }

    &.breadcrumbs-item--last-child {
      flex-direction: row;

      .breadcrumbs-item__separator {
        display: none;
      }

      // TODO: will be uncommented and implemented after 202401 release.
      // .breadcrumbs-item__link {
      //   color: $text-main-helper !important;
      //   pointer-events: none;
      // }
    }
  }

  // TODO: revisit hover based on design
  &.breadcrumbs-item--primary {
    .breadcrumbs-item__separator {
      color: $icon-interactive;
    }
  }

  &.breadcrumbs-item--white, &.breadcrumbs-item--white.breadcrumbs-item--orphan {
    .breadcrumbs-item__link,
    .breadcrumbs-item__link:hover,
    .breadcrumbs-item__link:active {
      color: rgba($link-on-color, 0.8 );
    }

    .breadcrumbs-item__separator {
      color: rgba($icon-on-color, 0.8 );
    }
  }

  &.breadcrumbs-item--orphan,
  &.breadcrumbs-item--last-child {
    flex-direction: row-reverse;

    .breadcrumbs-item__separator {
      transform: rotate(180deg);
      padding-right: 0;
    }
  }
}

.breadcrumbs-item__link {
  @include anchor;
  font-weight: inherit;
}

.breadcrumbs-item__separator {
  min-width: 1.4rem;
  height: 1.4rem;
  padding-left: 0.4rem;
  padding-right: 0.4rem;
  display: flex;
  align-items: center;
}
